//核心业务
const mainServiceData = [
    {
      title:'中东FBA/FBN专线',
      content:'',
      contentItem:[
        {
          title:'',
          content:'中东FBA/FBN专线，渠道稳定，时效有保障'
        },
        {
          title:'',
          content:'亚马逊SPN服务商，FBA免预约送仓'
        },
        {
          title:'',
          content:'丰富的NOON送仓经验，FBN送仓成功率高'
        },
      ],
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/FBA.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=WQr9k9uavY%2FsWWItsdtF336%2FCuU%3D",
      imageType:'left',
    },
    {
      title:'空运海运门到门',
      content:'',
      contentItem:[
        {
          title:'沙特空运时效：',
          content:'5-7天'
        },
        {
          title:'沙特海运时效：',
          content:'35-40天'
        },
        {
          title:'阿联酋空运时效：',
          content:'8-12天'
        },
        {
          title:'阿联酋海运时效：',
          content:'28-35天'
        },
      ],
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/air2.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=MgJzb6nQoZpEHyQ7gQ27dPec4Ys%3D",
      imageType:'right',
    },
    {
      title:'海外仓',
      content:'',
      contentItem:[
        {
          title:'中东网络：',
          content:'自营沙特/阿联酋海外仓'
        },
        {
          title:'规模领先：',
          content:'面积近10000平方米，可容纳1200+个标准托盘，设有10000+个电商库位'
        },
        {
          title:'合规安全：',
          content:'海外仓全套合规认证，合法雇佣劳工，确保客户货物安全保障'
        },
        {
          title:'服务内容：',
          content:'提供FBA/FBN暂存转运、一件代发、退货换标等全方位服务'
        },
      ],
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/owh2.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=aQ6lBoG6F5jq4g2583hW8fxnWMM%3D",
      imageType:'left',
    },
    {
      title:'海运整柜清关',
      content:'',
      contentItem:[
        {
          title:'',
          content:'自有清关行，提供多种清关方案'
        },
        {
          title:'',
          content:'专业的清关团队，丰富的证书清关经验'
        },
      ],
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/fcl3.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=GKN1BTyOfjTNRHzs3OpnmEuntmo%3D",
      imageType:'right',
    },
    {
      title:'Saber证书',
      content:'',
      contentItem:[
        {
          title:'',
          content:'丰富的证书制作经验，快速匹配产品及对应证书'
        },
        {
          title:'',
          content:'发证速度快，SC可当天出证'
        },
      ],
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/package4.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=HbZf67wpbdAYiPiCeF8%2Bs7kNlUo%3D",
      imageType:'left',
    },
    {
      title:'B2C小包',
      content:'',
      contentItem:[
        {
          title:'',
          content:'签收率高，时效快'
        },
        {
          title:'',
          content:'自有海外仓+成熟本土派送团队'
        },
        {
          title:'',
          content:'提供COD解决方案'
        },
      ],
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/package.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=vOp9d8pq10d3cIVpFHod%2BQ0sklc%3D",
      imageType:'right',
    },
]

export default mainServiceData



// WEBPACK FOOTER //
// ./src/view/homePage/content/mainService/json.js